
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.375 1C3.61875 1 3.00687 1.63 3.00687 2.4L3 13.6C3 14.37 3.61187 15 4.36812 15H12.625C13.3813 15 14 14.37 14 13.6V5.781C14 5.41 13.8556 5.053 13.5944 4.794L10.2737 1.413C10.0194 1.147 9.66875 1 9.30438 1H4.375ZM9.1875 5.1998V2.0498L12.9688 5.8998H9.875C9.49687 5.8998 9.1875 5.5848 9.1875 5.1998Z","fill":"#00A769"}})])
          )
        }
      }
    